import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

// Cambia estas rutas por las tuyas
import logo from "../assets/img/introduccion1.jpg";
import leftImage from "../assets/img/intro-image.jpg";

export default function IntroSection({
  title = "INTRODUCCIÓN",
  missionTitle = "Nuestra misión es clara:",
  missionText = `Brindar soluciones de alta calidad a nuestros clientes, garantizando transparencia
y profesionalismo en cada etapa del proceso. Con un equipo de expertos y un enfoque
centrado en la innovación, Kuelly es la empresa que necesitas para tus proyectos inmobiliarios.`,
  imageLeft = leftImage,

  logoSrc = logo,
}) {
  const KU_GREEN = "#2f5d35";
  const ACCENT = "#cfe6c5";

  return (
    <section className="position-relative overflow-hidden">
      <style>{`
        :root { --ku-green: ${KU_GREEN}; --ku-accent: ${ACCENT}; }

        .intro-wrap{ min-height: 68vh; }
        @media (max-width: 991.98px){ .intro-wrap{ min-height: auto; } }

        /* Col izquierda: imagen principal */
        .intro-left img{
          width:100%; height:100%; object-fit:cover;
          max-height: 620px;
        }
        @media (max-width: 991.98px){
          .intro-left img{ max-height: 320px; }
        }

        

        /* Panel derecho */
        .intro-right{
          background: var(--ku-green); color:#fff; position:relative;
          border-left:3px solid #111;
        }

        /* Marca / logo */
        .intro-brand{ display:flex; align-items:center; gap:14px; }
        .intro-logo{
          width: clamp(160px, 42vw, 480px);
          height:auto;
        }

        /* Título de bloque */
        .intro-title{
          font-weight:900; letter-spacing:.02em; line-height:1.02; margin: 8px 0 6px 0;
          color: var(--ku-accent);
          font-size: clamp(22px, 5.6vw, 52px);
        }

        /* Subtítulos y texto */
        .intro-mission-x{
          display:inline-flex; align-items:center; justify-content:center;
          width:22px; height:22px; border-radius:50%;
          background:#0e0e0e; color:#fff; font-weight:800; margin-right:10px;
        }
        .intro-divider{ height:2px; background:rgba(255,255,255,.35); margin:12px 0 16px; border-radius: 2px; }

        .intro-text{
          font-size: clamp(14px, 2.2vw, 18px);
          line-height: 1.6;
          max-width: 680px;
        }

       

        /* Orden de columnas en móvil: texto primero */
        @media (max-width: 991.98px){
          .intro-col-right{ order:1; }
          .intro-col-left{ order:2; }
          
         .intro-col-left {
            display: flex;
            justify-content: center; /* centra horizontalmente */
            align-items: center;     /* centra verticalmente si hay altura extra */
            background-color: #2f5d35; /* verde corporativo */
            padding: 1rem;           /* espacio alrededor de la imagen */
          }

          .intro-col-left img {
            width: clamp(300px, 70%, 700px); /* tamaño adaptable */
            height: auto;
            object-fit: contain; /* evita cortes */
          }



        }
      `}</style>

      <Container fluid className="p-0">
        <Row className="g-0 intro-wrap">
          {/* Izquierda: imagen grande (en móvil pasa abajo) */}
          <Col xs={12} lg={4} className="intro-left intro-col-left">
            <Image src={imageLeft} alt="Instalaciones Kuelly" fluid />
          </Col>

          {/* Derecha: panel verde (en móvil va arriba) */}
          <Col
            xs={12}
            lg={8}
            className="intro-right p-4 p-md-5 intro-col-right"
          >
            {/* Marca */}
            <div className="intro-brand mb-2">
              <Image src={logoSrc} alt="Kuelly" className="intro-logo" />
            </div>

            {/* Misión */}
            <div className="mb-2">
              <span className="intro-mission-x">×</span>
              <span
                className="fw-bold"
                style={{ fontSize: "clamp(14px, 2.4vw, 18px)" }}
              >
                {missionTitle}
              </span>
            </div>

            <div className="intro-divider" />

            <p className="mb-4 intro-text">{missionText}</p>

            {/* Foto pequeña superpuesta / fluida según breakpoint */}
            {/* <Image src={imageThumb} alt="Obra Kuelly" className="intro-thumb" /> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
